
import React, { useState } from 'react';

import { IsModemAccess, getToken, utc_local } from '../../../helpers/Helper';
import { POST_ENQUIRY_LIST, POST_DELETE_ENQUIRY, POST_UPDATE_ENQUIRY_STATUS } from '../../../helpers/url_helper';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";
import { del, post } from '../../../helpers/api_helper';


const UserRoles = (props) => {
    const navigate = useNavigate();
    const [Id, SetId] = useState(0);
    const [EnquiriesInfo, SetEnquiriesInfo] = useState(null);

    useMounted(() => {
        if (!IsModemAccess('enquiry', 'view')) {
            toast.error('Does not permission this module');
            navigate("/admin/dashboard");
        }
        get_invoice_list()
    }, [navigate])

    const get_invoice_list = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [4, 5] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_ENQUIRY_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "id" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.createdAt)}
                            </>)
                        }
                    },
                    { "data": "name" },
                    { "data": "mobileNo" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.status === 'Pending' && <span className='border-0 badge bg-info pointer'>{data.status}</span>}
                                {data.status === 'Completed' && <span className='border-0 badge bg-success pointer'>{data.status}</span>}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button className="btn btn-sm text-primary mr-2" data-bs-toggle="modal" data-bs-target="#viewModal" onClick={() => { SetEnquiriesInfo(data); }} ><i className="bx bx-edit"></i></button>
                                {IsModemAccess('enquiry', 'delete') && <button className="btn btn-sm text-danger" onClick={() => { SetId(data.id); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>}
                            </>)
                        }
                    },

                ]
            });
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(POST_DELETE_ENQUIRY + "?id=" + Id);
        if (res_data.status) {
            toast(res_data.message);
            get_invoice_list();
        } else {
            toast.error(res_data.message);
        }
    }
    // remove user role
    const updateStatus = async () => {
        var res_data = await post(POST_UPDATE_ENQUIRY_STATUS, EnquiriesInfo);
        if (res_data.status) {
            toast(res_data.message);
            get_invoice_list();
        } else {
            toast.error(res_data.message);
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Enquiries </h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>

                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Id</td>
                                            <td>Date</td>
                                            <td>Name</td>
                                            <td>Mobile Number</td>
                                            <td>Status</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="viewModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">View Enquiry</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {EnquiriesInfo && <div className='row'>
                                <div className='col-sm-6 mb-3'>
                                    <label><b>Name :</b></label> <br />
                                    {EnquiriesInfo.name}
                                </div>
                                <div className='col-sm-6 mb-3'>
                                    <label><b>Mobile No :</b></label> <br />
                                    {EnquiriesInfo.mobileNo}
                                </div>
                                <div className='col-sm-6 mb-3'>
                                    <label><b>Status :</b></label> <br />
                                    <select name='status' value={EnquiriesInfo.status} onChange={(e) => { EnquiriesInfo.status = e.target.value; SetEnquiriesInfo({...EnquiriesInfo}) }} className="form-control" >
                                        <option value="Pending">Pending</option>
                                        <option value="Completed">Completed</option>
                                    </select>
                                </div>
                                <div className='col-sm-6 mb-3'>
                                    <label><b>Date :</b></label> <br />
                                    {utc_local(EnquiriesInfo.createdAt)}
                                </div>
                                <div className='col-sm-12'>
                                    <label><b>Message :</b></label> <br />
                                    {EnquiriesInfo.message}
                                </div>
                            </div>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button onClick={updateStatus.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserRoles;